export const ContactOutcomes = {
    APPOINTMENT_SCHEDULED: "Appointment Scheduled",
    LEFT_VOICEMAIL: "Left Voicemail",
    INFORMATION_PROVIDED: "Information Provided",
    RESCHEDULED: "Rescheduled",
    PENDING_RESPONSE: "Pending Response",
    COMPLETED_ASSESSMENT: "Completed Assessment",
    AUTHORIZATION_OBTAINED: "Authorization Obtained",
    FOLLOW_UP_REQUIRED: "Follow-up Required",
    SERVICES_INITIATED: "Services Initiated",
    DOCUMENTATION_COMPLETED: "Documentation Completed"
};
